// Словарь распространённых русских имён (полные и уменьшительные формы, т.к. в Telegram
// first_name чаще всего — обиходное имя) → пол. Источник для `guessGenderByName`.
import type { Gender } from '../types'

export const FEMALE_NAMES: readonly string[] = [
  'анастасия',
  'настя',
  'настюша',
  'мария',
  'маша',
  'машенька',
  'анна',
  'аня',
  'анюта',
  'елена',
  'лена',
  'алёна',
  'алена',
  'ольга',
  'оля',
  'татьяна',
  'таня',
  'наталья',
  'наталия',
  'наташа',
  'ирина',
  'ира',
  'екатерина',
  'катя',
  'катюша',
  'юлия',
  'юля',
  'светлана',
  'света',
  'дарья',
  'даша',
  'полина',
  'поля',
  'виктория',
  'вика',
  'ксения',
  'ксюша',
  'кристина',
  'алина',
  'алиса',
  'вероника',
  'ника',
  'софия',
  'софья',
  'соня',
  'арина',
  'диана',
  'яна',
  'марина',
  'валентина',
  'людмила',
  'люда',
  'люся',
  'галина',
  'галя',
  'нина',
  'вера',
  'надежда',
  'надя',
  'любовь',
  'люба',
  'зоя',
  'элина',
  'эльвира',
  'карина',
  'милана',
  'мила',
  'василиса',
  'ева',
  'амина',
  'лилия',
  'лиля',
  'жанна',
  'инна',
  'изабелла',
  'белла',
  'маргарита',
  'рита',
  'регина',
  'снежана',
  'тамара',
  'юлианна',
  'элла',
]

export const MALE_NAMES: readonly string[] = [
  'александр',
  'саша',
  'сашка',
  'алексей',
  'лёша',
  'леша',
  'лёха',
  'леха',
  'андрей',
  'андрюша',
  'антон',
  'артём',
  'артем',
  'тёма',
  'тема',
  'борис',
  'боря',
  'вадим',
  'вадик',
  'валентин',
  'валя',
  'валерий',
  'валера',
  'василий',
  'виктор',
  'витя',
  'виталий',
  'виталик',
  'владимир',
  'вова',
  'володя',
  'владислав',
  'влад',
  'вячеслав',
  'слава',
  'геннадий',
  'гена',
  'георгий',
  'гоша',
  'жора',
  'глеб',
  'григорий',
  'гриша',
  'даниил',
  'данила',
  'даня',
  'денис',
  'дмитрий',
  'дима',
  'митя',
  'евгений',
  'женя',
  'егор',
  'иван',
  'ваня',
  'игорь',
  'илья',
  'кирилл',
  'константин',
  'костя',
  'леонид',
  'лёня',
  'леня',
  'максим',
  'макс',
  'михаил',
  'миша',
  'никита',
  'николай',
  'коля',
  'олег',
  'павел',
  'паша',
  'пава',
  'пётр',
  'петр',
  'петя',
  'роман',
  'рома',
  'ростислав',
  'руслан',
  'семён',
  'семен',
  'сёма',
  'сема',
  'сергей',
  'серёжа',
  'сережа',
  'станислав',
  'стас',
  'степан',
  'тимофей',
  'тима',
  'тимур',
  'фёдор',
  'федор',
  'федя',
  'эдуард',
  'эдик',
  'юрий',
  'юра',
  'ярослав',
]

/**
 * Имена, у которых уменьшительная форма одинаково используется и мужчинами, и женщинами
 * (Саша/Александр(-а), Женя/Евгений(-я), Валя/Валентин(-а), Шура — от Александра любого пола) —
 * спека 02 §A1: «неоднозначные (Саша, Женя, Валя) — показываем A1·2».
 */
export const AMBIGUOUS_NAMES: readonly string[] = ['саша', 'сашка', 'женя', 'валя', 'шура', 'вася']

export const NAME_GENDER_MAP: Readonly<Record<string, Gender>> = Object.freeze(
  Object.fromEntries([
    ...FEMALE_NAMES.map((name) => [name, 'f'] as const),
    ...MALE_NAMES.map((name) => [name, 'm'] as const),
  ]),
)
